import Image from "next/image"
import React, { useEffect } from "react"

import { Trans, useTranslation } from "@bounce/i18n"
import { Intercom } from "@bounce/intercom"
import { isInStorybook, sleep } from "@bounce/util"
import { Button } from "@bounce/web-components"

import { Layout } from "../../../components/Generic/Layout/Layout"
import { useUrl } from "../../../libs/router"

import image from "./assets/support.png"

const SupportScreen = () => {
  const { t } = useTranslation("marketing-generic")
  const { absolutePath } = useUrl()

  const openNewConversation = async () => {
    if (isInStorybook()) return

    // Open and wait for Intercom to load before opening the message composer
    await Intercom.present()
    await sleep(1000)
    await Intercom.presentMessageComposer()
  }

  useEffect(() => {
    setTimeout(openNewConversation, 500)
  }, [])

  return (
    <Layout
      headProps={{
        url: absolutePath,
        title: t("page.support.metaTitle", "Bounce: Luggage Storage - Contact Support"),
        description: t(
          "page.support.metaDescription",
          "Bounce Luggage Storage Support | Talk to Bounce Support through the Bounce website and app",
        ),
      }}>
      <div className="mx-auto flex w-full max-w-[860px] flex-col items-center justify-center px-6 pt-12 pb-section md:flex-row md:items-start md:justify-start md:pt-6">
        <Image
          alt=""
          width={312}
          height={312}
          loading="eager"
          priority
          className="max-w-full object-contain"
          src={image}
        />
        <div className="mt-4 flex flex-1 flex-col md:mt-24 md:pl-12">
          <h1 className="title1 w-full break-words text-center text-black md:text-left">
            <Trans
              ns="marketing-generic"
              i18nKey="page.support.reachUsHereV1"
              defaults="Reach out to <br />Bounce support"
              components={{
                br: <br />,
              }}
            />
          </h1>
          <Button
            as="button"
            variant="primary"
            color="primary"
            onClick={openNewConversation}
            className="mt-8 w-full md:mt-11 md:w-fit">
            {t("page.support.chatV1", "Open Chat")}
          </Button>
          <p className="paragraph1 mt-3 w-full px-4 text-center md:mt-4 md:px-0 md:text-left">
            {t("page.support.description", "Note that it can take up to 20 minutes to receive a reply.")}
          </p>
        </div>
      </div>
    </Layout>
  )
}

export default SupportScreen
